import React, {useMemo} from 'react'
import {ReactComponent as BreedAreaIcon} from '../../../assets/icons/breed-area-icon.svg'
import {ReactComponent as SafeZoneIcon} from '../../../assets/icons/safe-zone-icon.svg'
import {ReactComponent as Preview3DIcon} from '../../../assets/icons/preview-3d-icon.svg'

// const templateHelpers = [
//     {
//         areaName: 'Print Area',
//         description: 'the FULL SIZE area to be printed',
//         className: 'border border-solid border-gray-700',
//     },
//     {
//         areaName: 'Breed Area',
//         description: 'extends beyond the safe zone for size adjustments',
//         className: 'bg-gray-400',
//     },
//     {
//         areaName: 'Safe Print Area',
//         description: 'keeps all important design elements inside',
//         className: 'shadow-1',
//     },
//     {
//         areaName: '3D Preview Area',
//         description: 'the size for mockup preview',
//         className: 'border-dashed border-success',
//     },
// ]

const templateHelpersRegularHasTemplate = [
    {
        areaName: 'Print Area',
        description: 'the FULL SIZE area to be printed',
        className: 'border border-solid border-gray-700',
    },
    {
        areaName: 'Safe Print Area',
        description: 'keeps all important design elements inside',
        className: 'border-dashed border-success',
    },
]

const templateHelpersType2D = [
    {
        areaName: 'Safe Print Area',
        description: 'keeps all important design elements inside',
        className: 'border-dotted shadow-1',
    },
]

const templateHelpers = [
    {
        areaName: 'Breed Area',
        description: [
            'Your design must <strong>fully cover</strong> this area.',
            'This ensures that the artwork won’t be cut off during production and will adapt correctly across different sizes.',
        ],
        icon: <BreedAreaIcon />,
        className: 'border border-solid border-gray-700',
    },
    {
        areaName: 'Safe Zone',
        description: [
            'The <strong>main elements</strong> of your design should be placed within this area.',
            'All important details, logos, and artwork inside the Safe Zone will always be visible across all sizes.',
        ],
        icon: <Preview3DIcon />,
        className: 'bg-gray-400',
    },
    {
        areaName: '3D Preview Area',
        description: [
            'The product’s <strong>3D preview</strong> will be displayed based on this outline.',
            'This area helps you visualize how your design will appear on the actual product.',
        ],
        icon: <SafeZoneIcon />,
        className: 'shadow-1',
    },
    // {
    //     areaName: '3D Preview Area',
    //     description: 'the size for mockup preview',
    //     icon: <BreedAreaIcon />,
    //     className: 'border-dashed border-success',
    // },
]

const TemplateHelper = ({has3DPreview, productCreatedType}) => {
    // let templates = has3DPreview ? templateHelpers : templateHelpers.slice(0, 3)
    // let templates = templateHelpers.slice(0, 3)
    const template = useMemo(() => {
        if (has3DPreview) return templateHelpers
        return templateHelpers.slice(0, 2)
    }, [has3DPreview, productCreatedType])

    // if (productCreatedType === 'regularHasTemplate' || productCreatedType === 'combineLayout') {
    //     templates = templateHelpersRegularHasTemplate
    // } else if (productCreatedType === 'type2D') {
    //     templates = templateHelpersType2D
    // }

    const renderTemplateDetail = (item) => {
        return (
            <div className={'d-flex align-items-start'}>
                <div>{item.icon}</div>
                <div className={'text-start px-2'}>
                    <p className={'font-medium mb-1'}>{item.areaName}</p>
                    <ul className={'list-disc'}>
                        {item.description.map((desc) => (
                            <li className={'text-start'} key={desc} dangerouslySetInnerHTML={{__html: desc}}></li>
                        ))}
                    </ul>
                </div>
            </div>
        )
    }

    return (
        <div
            className={'TemplateHelper list text-sm'}
            style={{
                '--gap': '0.25rem',
            }}
        >
            {template.map(renderTemplateDetail)}
        </div>
    )
}

export default TemplateHelper
